var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-field" },
    [
      _vm.ready
        ? _c("MotionZonesCanvas", {
            ref: "miniCanvas",
            attrs: {
              zones: _vm.view.preview.zones,
              config: _vm.view.preview.config,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "motion-zones-dialog",
          attrs: {
            width: "82%",
            title:
              "Motion Zones (" +
              (_vm.view.data.zones.isNewSchema ? "New Schema" : "Old Schema") +
              ")",
            visible: _vm.zoomIn,
          },
          on: {
            "update:visible": function ($event) {
              _vm.zoomIn = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "grid motion-zones-dialog__content" },
            [
              _c(
                "div",
                {
                  staticClass: "span-3 flex-row",
                  staticStyle: { "margin-right": "10px" },
                },
                [
                  _c(
                    "div",
                    [
                      _vm.view.data.selectedZone
                        ? _c(
                            "el-form",
                            {
                              ref: "form",
                              attrs: {
                                model: _vm.view.data.selectedZone,
                                rules: _vm.view.data.rules,
                                "label-position": "top",
                                "label-width": "170px",
                              },
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Zone", size: "mini" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "Select Zone",
                                        size: "small",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.selectedZoneChanged()
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.view.data.selectedZoneUniqueId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.view.data,
                                            "selectedZoneUniqueId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "view.data.selectedZoneUniqueId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.view.data.zones.filter(function (
                                        zone
                                      ) {
                                        return zone.drawn
                                      }),
                                      function (zone, index) {
                                        return _c("el-option", {
                                          key: zone.uniqueId,
                                          attrs: {
                                            label:
                                              "[" +
                                              (index + 1).toString() +
                                              "] " +
                                              zone.name,
                                            value: zone.uniqueId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Name",
                                    prop: "name",
                                    size: "mini",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small" },
                                    on: {
                                      change: function ($event) {
                                        return _vm.selectedZoneDataChanged()
                                      },
                                    },
                                    model: {
                                      value: _vm.view.data.selectedZone.name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.view.data.selectedZone,
                                          "name",
                                          $$v
                                        )
                                      },
                                      expression: "view.data.selectedZone.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Active",
                                    prop: "enabled",
                                    size: "mini",
                                  },
                                },
                                [
                                  _c("el-switch", {
                                    on: {
                                      change: function ($event) {
                                        return _vm.selectedZoneDataChanged()
                                      },
                                    },
                                    model: {
                                      value: _vm.view.data.selectedZone.enabled,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.view.data.selectedZone,
                                          "enabled",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "view.data.selectedZone.enabled",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.view.data.zones.isNewSchema
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Detection Types",
                                        prop: "properties.detection_types",
                                        size: "mini",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            multiple: "",
                                            filterable: "",
                                            "allow-create": "",
                                            size: "small",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.selectedZoneDataChanged()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.view.data.selectedZone
                                                .properties.detection_types,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.view.data.selectedZone
                                                  .properties,
                                                "detection_types",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "view.data.selectedZone.properties.detection_types",
                                          },
                                        },
                                        _vm._l(
                                          _vm.view.data.detectionTypes,
                                          function (detectionType) {
                                            return _c("el-option", {
                                              key: detectionType,
                                              attrs: {
                                                label: detectionType,
                                                value: detectionType,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.view.data.zones.isNewSchema
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Triggers",
                                        prop: "properties.trigger_ids",
                                        size: "mini",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            multiple: "",
                                            filterable: "",
                                            "allow-create": "",
                                            size: "small",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.selectedZoneDataChanged()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.view.data.selectedZone
                                                .properties.trigger_ids,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.view.data.selectedZone
                                                  .properties,
                                                "trigger_ids",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "view.data.selectedZone.properties.trigger_ids",
                                          },
                                        },
                                        _vm._l(
                                          _vm.view.data.triggers,
                                          function (trigger) {
                                            return _c("el-option", {
                                              key: trigger.id,
                                              attrs: {
                                                label: trigger.name,
                                                value: trigger.id,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("MotionZonesCanvas", {
                ref: "zoomInCanvas",
                staticClass: "span-9 zoom-in-zones-wrapper",
                attrs: {
                  zones: _vm.view.data.zones,
                  config: _vm.view.data.config,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-row",
                { staticStyle: { height: "46px" }, attrs: { type: "flex" } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        "text-align": "left",
                        padding: "0px",
                        border: "initial",
                      },
                      attrs: { span: 12 },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { disabled: !_vm.canAddZones() },
                          on: {
                            click: function ($event) {
                              return _vm.addZone()
                            },
                          },
                        },
                        [_vm._v("\n            Add Zone\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: !_vm.view.data.selectedZone,
                            type: "danger",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removeZone()
                            },
                          },
                        },
                        [_vm._v("\n            Delete Zone\n          ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: { padding: "0px", border: "initial" },
                      attrs: { span: 12 },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.saveData()
                            },
                          },
                        },
                        [_vm._v("\n            Save\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.zoomIn = false
                            },
                          },
                        },
                        [_vm._v("\n            Close\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { padding: "10px", "text-align": "right" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini", circle: "" },
              on: {
                click: function ($event) {
                  _vm.zoomIn = true
                },
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-zoom-in",
                staticStyle: { "font-size": "x-large" },
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }